import Person1 from "./PersonsImages/Person1.jpg";
import Person2 from "./PersonsImages/Person2.jpg";
import Person3 from "./PersonsImages/Person3.jpg";
import Person4 from "./PersonsImages/Person4.jpg";
import Person5 from "./PersonsImages/Person5.jpg";
import Person6 from "./PersonsImages/Person6.jpg";
import Person7 from "./PersonsImages/Person7.jpg";
import Person8 from "./PersonsImages/Person8.jpg";
import Person9 from "./PersonsImages/Person9.jpg";
import Person10 from "./PersonsImages/Person10.jpg";
import Person11 from "./PersonsImages/Person11.jpg";

const Persons = [
  {
    ImageSrc: Person1,
    name: "Alex Rodriguez",
    description: "CEO, Co-founder",
  },
  {
    ImageSrc: Person2,
    name: "Eleonore Rundottir",
    description: "Planner",
  },
  {
    ImageSrc: Person3,
    name: "Gerald Mueller",
    description: "Planner",
  },
  {
    ImageSrc: Person4,
    name: "Kolby Huel",
    description: "Planner",
  },
  {
    ImageSrc: Person5,
    name: "Laney Corker",
    description: "Planner",
  },
  {
    ImageSrc: Person6,
    name: "Layla Colliera",
    description: "Planner",
  },
  {
    ImageSrc: Person7,
    name: "Marcus Sparks",
    description: "CFO, Co-founder",
  },
  {
    ImageSrc: Person8,
    name: "Marlon Schumm",
    description: "Planner",
  },
  {
    ImageSrc: Person9,
    name: "Myles Jordan",
    description: "Planner",
  },
  {
    ImageSrc: Person10,
    name: "Raven Jerde",
    description: "CCO, Co-founder",
  },
  {
    ImageSrc: Person11,
    name: "Roma Bins",
    description: "Planner",
  },
];

export default Persons;
